export const getFilters = (state) => state.filters;
export const getOffset = (state) => state.result.offset;
export const getItemsPerPage = (state) => state.result.itemsPerPage;
export const getWebcodeNoResult = (state) => state.webcode.noResultTerm;
export const getSortOptions = (state) => state.sortOptions;
export const getCollapseLicenseForms = (state) => state.collapseLicenseForms;
export const getMaxSuggestions = (state) => state.suggestions.limit;
export const getRankingStrategy = (state) => state.rankingStrategy;
